import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/asana.vue
var s = {
	name: "DtIconAsana",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["fill"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--asana"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Asana",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("path", {
		d: "M17.65 12.787a4.35 4.35 0 1 0 0 8.699 4.35 4.35 0 0 0 0-8.7Zm-11.3 0a4.35 4.35 0 1 0 0 8.7 4.35 4.35 0 0 0 0-8.7Zm10-5.437a4.35 4.35 0 1 1-8.7 0 4.35 4.35 0 0 1 8.7 0Z",
		fill: `url(#${e.uniqueID}a)`
	}, null, 8, l), i("defs", null, [i("radialGradient", {
		id: `${e.uniqueID}a`,
		cx: "0",
		cy: "0",
		r: "1",
		gradientUnits: "userSpaceOnUse",
		gradientTransform: "matrix(13.2526 0 0 12.2495 12 13.103)"
	}, [...t[0] || (t[0] = [
		i("stop", { "stop-color": "#FFB900" }, null, -1),
		i("stop", {
			offset: ".6",
			"stop-color": "#F95D8F"
		}, null, -1),
		i("stop", {
			offset: ".999",
			"stop-color": "#F95353"
		}, null, -1)
	])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=asana.js.map